<header class="candidate-nav__header" [ngClass]="{'candidate-nav__header--scrolled': isScrolled}">
    <!-- Progress Bar -->
    <div class="candidate-nav__progress" [style.width.%]="scrollProgress"></div>

    <!-- Banner -->
    <div class="candidate-nav__banner"
        [ngClass]="{'candidate-nav__banner--hidden': !bannerVisible, 'candidate-nav__banner--visible': bannerVisible}">
        <div class="candidate-nav__banner-content">
            <svg aria-hidden="true" class="candidate-nav__banner-icon" fill="none" stroke="currentColor"
                stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg">
                <rect height="20" rx="2" ry="2" width="14" x="5" y="2"></rect>
                <path d="M12 18h.01"></path>
            </svg>
            <span class="candidate-nav__banner-text">Get the BeExpert.ai app — practice, apply &amp; track jobs on the
                go.</span>
            <span class="candidate-nav__banner-text-mobile">Get the BeExpert.ai app.</span>
            <a href="https://play.google.com/store/apps/details?id=com.acelucid.mind_mentor_pro" target="_blank"
                rel="noopener noreferrer" style="text-decoration: none;" class="candidate-nav__download-btn"
                data-testid="app-download-btn">
                Download App
                <svg aria-hidden="true" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 12h14"></path>
                    <path d="m12 5 7 7-7 7"></path>
                </svg>
            </a>
            <button (click)="dismissBanner()" aria-label="Dismiss banner" class="candidate-nav__close-btn"
                data-testid="app-banner-close">
                <svg aria-hidden="true" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                    stroke-width="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6 6 18"></path>
                    <path d="m6 6 12 12"></path>
                </svg>
            </button>
        </div>
    </div>

    <!-- Navbar -->
    <div class="candidate-nav__wrapper" [ngClass]="{'candidate-nav__wrapper--scrolled': isScrolled}">
        <nav class="candidate-nav__navbar" [ngClass]="{'candidate-nav__navbar--scrolled': isScrolled}">
            <!-- Brand (Logo + Mobile Recruiter Btn) -->
            <div class="candidate-nav__brand">
                <button class="candidate-nav__logo-link cursor-pointer" data-testid="nav-logo"
                    (click)="scrollTo('app-hero')">
                    <img alt="BeExpert.ai" class="candidate-nav__logo-img candidate-nav__logo-img--desktop"
                        src="/assets/images/BeExpert-logo%20(2).svg" />
                    <img alt="BeExpert.ai" class="candidate-nav__logo-img candidate-nav__logo-img--mobile"
                        src="/assets/images/beExpert-logo-new.png" />
                </button>

                <div class="candidate-nav__mobile-buttons">
                    <button class="candidate-nav__login-btn candidate-nav__login-btn--mobile" routerLink="/login">
                        Login
                    </button>
                    <button class="candidate-nav__candidate-btn candidate-nav__candidate-btn--mobile"
                        routerLink="/recruiter" data-testid="nav-recruiter-btn-mobile">
                        For Employers </button>
                </div>
            </div>

            <!-- Links (Desktop) -->
            <div class="candidate-nav__links">
                <button class="candidate-nav__link" (click)="scrollTo('app-featured-jobs')"
                    data-testid="nav-link-jobs">Jobs</button>
                <!-- <button class="candidate-nav__link" (click)="scrollTo('app-mock-interviews')"
                    data-testid="nav-link-mock-interview">Mock Interview</button>
                <button class="candidate-nav__link" (click)="scrollTo('app-assessments')"
                    data-testid="nav-link-mock-test">Mock Test</button> -->
                <button class="candidate-nav__link" (click)="scrollTo('app-featured-mock-test')"
                    data-testid="nav-link-mock-test">Mock Test</button>
                    
                <!-- <button class="candidate-nav__link" (click)="scrollTo('app-featured-mock-interview')"
                    data-testid="nav-link-mock-interview">Mock Interview</button> -->

                <button class="candidate-nav__link" (click)="scrollTo('app-resume-builder')"
                    data-testid="nav-link-resume-builder">Resume Builder</button>
                <button class="candidate-nav__link" (click)="scrollTo('app-career-roadmap')"
                    data-testid="nav-link-placement-readiness">Placement Readiness</button>
                <button class="candidate-nav__link" (click)="scrollTo('app-testimonials')"
                    data-testid="nav-link-success-stories">Success Stories</button>
            </div>

            <!-- Actions (Desktop) -->
            <div class="candidate-nav__actions">
                <button class="candidate-nav__login-btn" routerLink="/login" data-testid="nav-login-btn">Login</button>
                <button class="candidate-nav__candidate-btn" routerLink="/recruiter" data-testid="nav-recruiter-btn">
                    For Employers <svg aria-hidden="true" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                        stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 12h14"></path>
                        <path d="m12 5 7 7-7 7"></path>
                    </svg>
                </button>
            </div>

            <!-- Mobile Toggle -->
            <button (click)="toggleMobileMenu()" class="candidate-nav__mobile-toggle" data-testid="nav-mobile-toggle">
                <svg *ngIf="!isMobileMenuOpen" aria-hidden="true" class="candidate-nav__icon" fill="none" height="24"
                    stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M4 12h16"></path>
                    <path d="M4 18h16"></path>
                    <path d="M4 6h16"></path>
                </svg>
                <svg *ngIf="isMobileMenuOpen" aria-hidden="true" class="candidate-nav__icon" fill="none" height="24"
                    stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18 6 6 18"></path>
                    <path d="m6 6 12 12"></path>
                </svg>
            </button>

            <!-- Mobile Menu Overlay -->
            <div *ngIf="isMobileMenuOpen" class="candidate-nav__mobile-menu">
                <div class="candidate-nav__mobile-links">
                    <button class="candidate-nav__mobile-link" (click)="scrollTo('app-featured-jobs')">Jobs</button>
                    <!-- <button class="candidate-nav__mobile-link" (click)="scrollTo('app-mock-interviews')">Mock
                        Interview</button>
                    <button class="candidate-nav__mobile-link" (click)="scrollTo('app-assessments')">Mock Test</button> -->
                    <button class="candidate-nav__mobile-link" (click)="scrollTo('app-resume-builder')">Resume
                        Builder</button>
                    <button class="candidate-nav__mobile-link" (click)="scrollTo('app-career-roadmap')">Placement
                        Readiness</button>
                    <button class="candidate-nav__mobile-link" (click)="scrollTo('app-testimonials')">Success
                        Stories</button>
                </div>
                <div class="candidate-nav__mobile-actions">
                    <button class="candidate-nav__mobile-login-btn" routerLink="/login"
                        (click)="toggleMobileMenu()">Login</button>
                    <button class="candidate-nav__mobile-candidate-btn" routerLink="/recruiter"
                        (click)="toggleMobileMenu()">For Employers</button>
                </div>
            </div>
        </nav>
    </div>
</header>